var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.circle") } },
    [
      _c("el-switch", {
        model: {
          value: _vm.optionModel.circle,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "circle", $$v)
          },
          expression: "optionModel.circle",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }